import {
  useVideoPlayer2,
  useVideoPlayerWatcher,
} from "./use-video-player-2-setup-start";

export function useVideoPlayer2Play() {
  const player = useVideoPlayer2();
  useVideoPlayerWatcher("playStateChanged");
  useVideoPlayerWatcher("ended");

  const handlePlayPauseRewind = () => {
    if (player.isEnded) {
      // If video is ended, rewind to start and play
      player.setCurrentTime(0);
      player.play();
    } else {
      // Normal play/pause toggle
      player.togglePlay();
    }
  };

  return {
    isPlaying: player.isPlaying,
    isEnded: player.isEnded,
    togglePlay: player.togglePlay,
    play: player.play,
    pause: player.pause,
    handlePlayPauseRewind,
  };
}

export function useVideoPlayer2ForwardRewind() {
  const player = useVideoPlayer2();

  return {
    forward: player.forward,
    rewind: player.rewind,
  };
}
